import { RiEyeLine } from "react-icons/ri";
import { Link } from "react-router-dom";

export const config = (onView, withFilter) => [
  {
    name: "Numéro contrat",
    selector: (row) => row.contract_number,
    sortable: true,
    filterable: withFilter,
  },
  // {
  //   name: "Nom du client",
  //   selector: (row) => row.name,
  //   sortable: true,
  //   filterable: withFilter,
  // },
  {
    name: "Etat du contrat",
    selector: (row) => row.status,
    sortable: true,
    filterable: withFilter,
    cell: (row) =>
      row.status === "MIS EN FORCE" ? (
        <div className="chip-status success">{row.status}</div>
      ) : (
        row.status
      ),
  },

  {
    name: "Montant de financement",
    selector: (row) => row.amount,
    sortable: true,
    filterable: withFilter,
    cell: (row) => (row.amount === 0 ? "" : row.amount),
  },
  // {
  //   name: "Encours",
  //   selector: (row) => row.current,
  //   sortable: true,
  //   filterable: withFilter,
  // },
  {
    name: "Date de mise en force",
    selector: (row) => row.effective_date,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Matériel",
    selector: (row) => row.project,
    sortable: true,
    filterable: withFilter,
  },
  // {
  //   name: "Date fin du contrat",
  //   selector: (row) => row.end_date,
  //   sortable: true,
  //   filterable: withFilter,
  // },
  {
    name: "Montant loyer TTC",
    selector: (row) => row.due_amount,
    sortable: true,
    filterable: withFilter,
    cell: (row) => (row.due_amount === 0 ? "" : row.due_amount),
  },
  {
    name: "Date dernière échéance",
    selector: (row) => row.due_date,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Détails",
    selector: (row) => row.contract_number,
    cell: (row) => (
      <>
        {row.show_detail_link ? (
          <Link to={`/global-situation/${row.contract_number}`}>
            <RiEyeLine />
          </Link>
        ) : (
          ""
        )}
      </>
    ),
  },
];
